import {AVAILABLE_ACTIONS, CONSUMER_INIT_STATE} from "../utils/constants";

export function consumerReducer(state, action) {
    switch (action.type) {
        case AVAILABLE_ACTIONS.INIT: {
            return CONSUMER_INIT_STATE;
        }
        case AVAILABLE_ACTIONS.UPDATE_ADDRESS: {
            let newAddress = {...state, ...action.userRequest};
            return Object.assign({}, state, newAddress);
        }
        case AVAILABLE_ACTIONS.MOVE_NEXT: {
            return Object.assign({}, state, {wizardStep: action.wizardStep});
        }
        case AVAILABLE_ACTIONS.ADDRESS_ERROR: {
            let errors = Object.assign({}, {address: action.errors});
            return Object.assign({}, state, {userRequestId: "ERR"}, {errors: errors});
        }
        case AVAILABLE_ACTIONS.UPDATE_PROPERTY_REQUIREMENT: {
            let newPropRequirement = {...state, ...action.userRequest};
            return Object.assign({}, state, newPropRequirement);
        }
        case AVAILABLE_ACTIONS.UPDATE_PROPERTY_DETAILS: {
            let newPropDetails = {...state, ...action.userRequest};
            return Object.assign({}, state, newPropDetails);
        }
        case AVAILABLE_ACTIONS.UPDATE_OTHER_DETAILS: {
            let newOtherDetails = {...state, ...action.userRequest};
            return Object.assign({}, state, newOtherDetails);
        }
        case AVAILABLE_ACTIONS.UPDATE_PETS: {
            let newPetDetails = {...state, ...action.userRequest};
            return Object.assign({}, state, newPetDetails);
        }
        case AVAILABLE_ACTIONS.UPDATE_CONTACTINFO: {
            let contactInfo = {...state, ...action.userRequest};
            return Object.assign({}, state, contactInfo);
        }
        default: {
            throw new Error(`Unhandled type: ${action.type}`)
        }
    }
}